import { Link } from '@inertiajs/react';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface BackToDirectoryButtonProps {
  className?: string;
}

const BackToDirectoryButton = ({ className = "" }: BackToDirectoryButtonProps) => (
  <Button variant="ghost" asChild className={className}>
    <Link href="/speakers" className="flex items-center gap-2">
      <ArrowLeft className="w-4 h-4" />
      <span className="sm:hidden">Back</span>
      <span className="hidden sm:inline">Back to Directory</span>
    </Link>
  </Button>
);

export default BackToDirectoryButton;